import React, { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { brazeInit, brazeScript } from 'analytics/braze';

import RedirectComponent from 'components/utils/RedirectComponent';

import { AUTH_SEND_MAIN_LINK, LOGIN, REGISTRATION } from 'constants/UrlConstants';

import { removeScript } from 'helpers/DOM';

import landing from 'routes/landing';

import NotFound from '../NotFound';

const App = ({ routes = [], ...props }) => {
    const authUser = props.authUser;
    const redirectTo = props.redirectTo;

    useEffect(() => {
        if (__isBrowser__) {
            if (document.readyState === 'complete') {
                brazeInit();
            } else {
                window.addEventListener('load', brazeInit, { once: true });
            }
        }
        return () => removeScript(brazeScript);
    }, []);

    return (
        <>
            <Routes>
                {routes.map(({ path, exact, component: Component, stateOptions, renderOptions, ...rest }) => {
                    const isRedirect =
                        (authUser && (path === LOGIN || path === REGISTRATION)) || (!authUser && rest.isAuthZone) || (redirectTo && redirectTo !== path);
                    const redirectUrl = redirectTo ? redirectTo : isRedirect && authUser ? AUTH_SEND_MAIN_LINK : LOGIN;
                    return (
                        <Route
                            key={path}
                            path={path}
                            exact={exact}
                            element={
                                isRedirect ? (
                                    <Navigate to={redirectUrl} />
                                ) : (
                                    <Component reloadData={isRedirect} renderOptions={renderOptions} stateOptions={stateOptions} data={props.data} />
                                )
                            }
                        />
                    );
                })}
                {landing.map(({ path, exact }) => {
                    if (Array.isArray(path)) {
                        return path.map((p) => <Route key={p} path={p} exact={exact} element={<RedirectComponent key={p} />} />);
                    }
                    return <Route key={path} path={path} exact={exact} element={<RedirectComponent />} />;
                })}
                <Route path="*" element={<NotFound />} />
            </Routes>
        </>
    );
};
export default App;
